import { Link } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';
import { ArrowRight } from 'lucide-react';

interface HomeCategoryCardProps {
  to: string;
  title: string;
  description: string;
  count?: number;
  image?: string;
  icon: LucideIcon;
  accentColor: string;
}

export function HomeCategoryCard({
  to,
  title,
  description,
  count,
  image,
  icon: Icon,
  accentColor,
}: HomeCategoryCardProps) {
  return (
    <Link to={to} className="wl5-home-cat-card">
      {image && (
        <img src={image} alt="" className="wl5-home-cat-card-bg" loading="lazy" />
      )}
      <div className="wl5-home-cat-card-overlay" aria-hidden="true" />
      <div className="wl5-home-cat-card-body">
        <span className="wl5-home-cat-card-icon" style={{ backgroundColor: `${accentColor}18`, color: accentColor }}>
          <Icon className="h-5 w-5" />
        </span>
        <div className="wl5-home-cat-card-copy">
          <h3 className="wl5-home-cat-card-title">{title}</h3>
          <p className="wl5-home-cat-card-desc">{description}</p>
          {count !== undefined && count > 0 && (
            <p className="wl5-home-cat-card-count">{count} {count === 1 ? 'veículo' : 'veículos'}</p>
          )}
        </div>
        <span className="wl5-home-cat-card-cta" style={{ color: accentColor }}>
          Ver
          <ArrowRight className="h-4 w-4" />
        </span>
      </div>
    </Link>
  );
}
